import Answer from "./Answer";
import Option from "./Option";
import { QuestionCategory } from "./QuestionCategory";
export default class Question {
  constructor({
    id = Number.NaN,
    name = "",
    slug = "",
    label = "",
    answer = null,
    suggestion = null,
    choices = [],
    datatype = null,
    helpText = "",
    helpFile = null,
    image = "",
    logicjumps = [],
    order = Number.NaN,
    required = false,
    readOnly = false,
    typeQuestion = "",
    group = null,
    groupName = null,
    step = Number.NaN,
    visibleClient = false,
    category = null,
    validation = "PENDING",
    hasFreeOption = false,
    answersCount = 0,
    conditions = "",
    errorMessage = "",
    usage = null,
    isOperationResult = false,
    isOperationSource = false,
  } = {}) {
    this.id = Number.parseInt(id);
    this.name = name;
    this.slug = slug;
    this.label = label;
    this.answer = answer ? new Answer(answer) : null;
    this.suggestion = suggestion ? suggestion : null;
    this.choices = choices ? choices.map((choice) => new Option(choice)) : [];
    this.datatype = datatype;
    this.datatypeId = Number.isSafeInteger(datatype)
      ? Number.parseInt(datatype)
      : datatype?.id;
    this.helpText = helpText;
    this.helpFile = helpFile;
    this.image = image;
    this.logicjumps = logicjumps;
    this.order = Number.parseInt(order);
    this.required = required;
    this.readOnly = readOnly;
    this.typeQuestion = typeQuestion;
    this.group = group;
    this.groupName = groupName;
    this.step = step ? Number.parseInt(step) : null;
    this.visibleClient = visibleClient;
    this.category =
      category && category.id ? new QuestionCategory(category) : null;
    this.validation = validation;
    this.hasFreeOption = hasFreeOption;
    this.answersCount = answersCount;
    this.conditions = conditions;
    this.errorMessage = errorMessage;
    this.usage = usage ? new QuestionUsage(usage) : null;
    this.isOperationResult = isOperationResult;
    this.isOperationSource = isOperationSource;
  }
}

export class QuestionUsage {
  constructor({ course = [], workflow = [] }) {
    this.course = course.map((d) => new QuestionUsageItem(d));
    this.workflow = workflow.map((d) => new QuestionUsageItem(d));
  }

  get count() {
    return this.course.length + this.workflow.length;
  }

  get isUsed() {
    return this.course.length || this.workflow.length;
  }
}

export class QuestionUsageItem {
  constructor({ id = NaN, name = "" }) {
    this.id = id;
    this.name = name;
  }
}
